<template>
    <hox-modal @close="close">
        <hox-loading-layer v-if="isDeletingFont" />
        <div class="delete-font-modal__alert-wrapper">
            <hox-alert type="danger" :margin-bottom="hasErrorDeletingFont ? 'base' : 'none'">
                <template #title>
                    Are you sure you want to delete the "
                    <em>{{ name }}</em>
                    " font?
                </template>
                <template #content>
                    <p>Deleting a font is permanent: it can not be recovered.</p>
                </template>
            </hox-alert>
        </div>
        <Alert v-if="hasErrorDeletingFont" banner type="error">
            <template #desc>Something went wrong and the font was not deleted. Try again in a few moments.</template>
        </Alert>
        <template #footer>
            <Button class="delete-font-modal__button" @click="close">Cancel</Button>
            <Button class="delete-font-modal__button" type="error" @click="deleteFont">Delete</Button>
        </template>
    </hox-modal>
</template>

<script setup lang="ts">
import { ref } from "vue";

import RemoveFontMutation from "@/apollo/mutations/RemoveFont.gql";
import { snackbar } from "@/utils";
import { apolloClient } from "@/apollo";

const { fontId, name } = defineProps<{ fontId: string; name: string }>();

const emit = defineEmits(["close", "fontDeleted"]);

const hasErrorDeletingFont = ref(false);
const isDeletingFont = ref(false);

function close() {
    emit("close");
}

async function deleteFont() {
    hasErrorDeletingFont.value = false;
    if (!isDeletingFont.value) {
        isDeletingFont.value = true;
        try {
            await apolloClient.mutate({
                mutation: RemoveFontMutation,
                variables: {
                    fontId
                }
            });

            snackbar.success(`The font "${name}" has been deleted`);

            emit("fontDeleted");
            close();
        } catch (err) {
            console.log(err);
            hasErrorDeletingFont.value = true;
            return;
        } finally {
            isDeletingFont.value = false;
        }
    }
}
</script>

<style lang="scss">
@use "@style/variables" as *;

.delete-font-modal {
    &__alert-wrapper {
        padding: $spacing 0 0;
    }

    &__button {
        margin: 0 0 0 $spacing-small;
    }
}
</style>
